<script lang="ts">
  const { size = 24, selected = false }: { size?: string | number; selected?: boolean } = $props();
</script>

<svg
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3"
    y="4"
    width="18"
    height="18"
    rx="2"
    ry="2"
    class='bg'
    class:selected
  />
  <line
    x1="16"
    y1="2"
    x2="16"
    y2="6"
  />
  <line
    x1="8"
    y1="2"
    x2="8"
    y2="6"
  />
  <path
    class='letter'
    class:selected
    d="m 16.077267,8.9227332 v 9.1545298 h -1.049593 v -6.826211 l -2.65282,6.826211 H 11.63668 L 8.9723269,11.237825 v 6.839438 H 7.9227332 V 8.9227332 H 9.0530647 L 12.005767,16.489772 14.95847,8.9227332 Z"
  />
</svg>

<style lang='scss'>
  @use 'sass:color';
  @use '~/theme/theme.scss';
  .letter.selected {
    stroke: theme.$star-bonus;
  }
  .bg.selected {
    fill: currentColor;
  }
</style>